import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { activityLogApi } from '@/lib/api/activity-log.api';

import type { ActivityLogQuery } from '@repo/shared-types';

const QUERY_KEY = ['activity-log'];

export const useActivityLog = (query: Partial<ActivityLogQuery> = {}, enabled = true) =>
  useQuery({
    queryKey: [...QUERY_KEY, query],
    queryFn: () => activityLogApi.getAll(query),
    enabled,
    // Paging through an audit trail shouldn't blank the table on every step.
    placeholderData: keepPreviousData,
  });

/** The history of one row — powers the Activity tab on a configuration. */
export const useEntityActivity = (entityType: string, entityId: string | undefined, limit = 50) =>
  useQuery({
    queryKey: [...QUERY_KEY, 'entity', entityType, entityId, limit],
    queryFn: () => activityLogApi.getAll({ entity_type: entityType, entity_id: entityId, limit }),
    enabled: Boolean(entityId),
  });

export const useActivityLogFacets = (enabled = true) =>
  useQuery({
    queryKey: [...QUERY_KEY, 'facets'],
    queryFn: () => activityLogApi.getFacets(),
    enabled,
    staleTime: 60_000,
  });
